import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_COST_CODE,
  API_CREATE_COST_CODE,
  API_LOAD_COST_CODES,
  API_REMOVE_COST_CODE,
  API_UPDATE_COST_CODE,
  REMOVE_LOCAL_COST_CODE,
} from './costCode.reducer';

export const load = () => ({ resourceAction: API_LOAD_COST_CODES });
export const save = resource => ((isLocal(resource.id)) ? {
  resourceAction: API_CREATE_COST_CODE,
  resource,
} : { resourceAction: API_UPDATE_COST_CODE, resource });
export const add = () => ({ type: ADD_LOCAL_COST_CODE });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_COST_CODE,
  id,
} : { resourceAction: API_REMOVE_COST_CODE, id });



// WEBPACK FOOTER //
// ./src/reducers/costCode/costCode.actions.js